import { render, staticRenderFns } from "./EVShowroom.vue?vue&type=template&id=830d8e6a&"
import script from "./EVShowroom.vue?vue&type=script&lang=js&"
export * from "./EVShowroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports